module.exports = __webpack_public_path__ + "Groups0002-37a92e60e06de5e1cef3470a94f72ee4.png";